<div class="heatmap-wrapper">
  <!-- Compact header -->
  <div class="heatmap-header">
    <div class="heatmap-header-left">
      <div class="heatmap-icon-ring" [ngClass]="{'heatmap-icon-hum': activeHeatmapSlug === 'humidity'}">
        <mat-icon>{{ activeHeatmapSlug === 'temperature' ? 'thermostat' : 'water_drop' }}</mat-icon>
      </div>
      <div>
        <h3>Warehouse Heatmap</h3>
        <p>Average zone {{ activeHeatmapSlug === 'temperature' ? 'temperature' : 'humidity' }} readings</p>
      </div>
    </div>
    <div class="heatmap-toggle-group">
      @for (tab of heatmapTabs; track tab) {
        <button (click)="activeHeatmapSlug = tab.slug" [class.active]="activeHeatmapSlug === tab.slug">
          {{ tab.name }}
        </button>
      }
    </div>
  </div>

  <!-- Grid body -->
  <div class="heatmap-body">
    @if (heatmapLoading) {
      <div class="heatmap-loading">
        <div class="heatmap-spinner"></div>
      </div>
    } @else if (heatmapData?.length > 0) {
      @for (warehouse of heatmapData; track warehouse.warehouse) {
        <div class="heatmap-row">
          <!-- Warehouse name on the left -->
          <div class="heatmap-row-label">
            <span class="name">{{ warehouse.warehouse }}</span>
          </div>

          <!-- Zone cells flowing horizontally next to warehouse name -->
          <div class="heatmap-row-cells">
            @for (zone of warehouse.zones; track zone.zone_id) {
              <div
                class="hm-cell"
                [style.background]="activeHeatmapSlug === 'temperature' ? getTempCellColor(zone.avg_temperature) : getHumCellColor(zone.avg_humidity)"
                [matTooltip]="zone.zone_name + ' — Temp: ' + zone.avg_temperature + '°C, Hum: ' + zone.avg_humidity + '%, Stability: ' + zone.stability_score + '%'"
              >
                <span class="hm-cell-name">{{ zone.zone_name }}</span>
                <span class="hm-cell-value">
                  @if (activeHeatmapSlug === 'temperature') {
                    {{ zone.avg_temperature }}&deg;
                  } @else {
                    {{ zone.avg_humidity }}%
                  }
                </span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Legend with range summary -->
      <div class="heatmap-legend">
        @if (activeHeatmapSlug === 'temperature') {
          <span class="legend-label">Cool</span>
          <div class="legend-gradient temp-gradient"></div>
          <span class="legend-label">Hot</span>
        } @else {
          <span class="legend-label">Dry</span>
          <div class="legend-gradient hum-gradient"></div>
          <span class="legend-label">Humid</span>
        }
      </div>
      <div class="heatmap-range-summary">
        @if (activeHeatmapSlug === 'temperature') {
          <span class="range-item" style="color: #52b868;">&#9632; &lt;15°C Cool</span>
          <span class="range-item" style="color: #8cbf4a;">&#9632; 15–20°C Mild</span>
          <span class="range-item" style="color: #e8c84a;">&#9632; 20–25°C Warm</span>
          <span class="range-item" style="color: #e8993a;">&#9632; 25–30°C Hot</span>
          <span class="range-item" style="color: #e8725a;">&#9632; 30–35°C Very Hot</span>
          <span class="range-item" style="color: #d94a4a;">&#9632; &gt;35°C Extreme</span>
        } @else {
          <span class="range-item" style="color: #96c6ea;">&#9632; &lt;35% Dry</span>
          <span class="range-item" style="color: #6ba8e0;">&#9632; 35–50% Low</span>
          <span class="range-item" style="color: #4a8ad6;">&#9632; 50–65% Moderate</span>
          <span class="range-item" style="color: #3a6fc4;">&#9632; 65–80% High</span>
          <span class="range-item" style="color: #2b52a4;">&#9632; &gt;80% Very Humid</span>
        }
      </div>
    } @else {
      <div class="heatmap-empty">
        <mat-icon>grid_off</mat-icon>
        <span>No heatmap data available</span>
      </div>
    }
  </div>
</div>
